export const StandardPlanData = [
    "Total 5000 conversation/month",
        "Sales chat box",
        "Whatsapp marketing analytics and scheduling",
        "Ticket system (Using Round Robin)",
        "Mobile App (Available on Android & IOS)",
]